import React, { Component } from "react"
import { Link } from "react-router-dom"
import "../../../assets/style.css"
import "../style.css"
import { DropdownMenu, DropdownItem, DropdownToggle, Collapse, NavbarToggler, UncontrolledDropdown } from "reactstrap"

class GatewayList extends Component {
    state = {
        isOpen: false,
        isOpenFilter: false
    }

    render() {
        const { gateways, setView } = this.props

        return(
            <div className="hdv-gateway-container">
                <div className="row" style={{borderBottom: '1px solid #0000001f'}}>
                    <div className="col-md-12 d-flex align-items-center justify-content-between" style={{margin: "0 5px"}}>
                        <h6 style={{fontSize: "18px", fontWeight: "bold"}}>Gateways</h6>
                        <UncontrolledDropdown nav inNavbar>
                            <DropdownToggle nav className="hdv-navbar-item">
                                <i className="las la-filter mr-2 la-2x" style={{cursor: "pointer"}}></i>
                            </DropdownToggle>
                            <DropdownMenu className="mini-modal" right>
                                <DropdownItem onClick={() => this.props.changeFilterGatewayState('TODOS')}>
                                    <div className="status-gateway-container" style={{gap: "3px", cursor: "pointer"}} >
                                        <div className="status-gateway blue" style={{cursor: "pointer"}}></div>
                                        <span className="status-gateway-text">Todos</span>
                                    </div>
                                </DropdownItem>
                                <DropdownItem onClick={() => this.props.changeFilterGatewayState(1)}>
                                    <div className="status-gateway-container" style={{gap: "3px", cursor: "pointer"}} >
                                        <div className="status-gateway green" style={{cursor: "pointer"}}></div>
                                        <span className="status-gateway-text">Ativo</span>
                                    </div>
                                </DropdownItem>
                                <DropdownItem onClick={() => this.props.changeFilterGatewayState(2)}>
                                    <div className="status-gateway-container" style={{gap: "3px", cursor: "pointer"}} >
                                        <div className="status-gateway red" style={{cursor: "pointer"}}></div>
                                        <span className="status-gateway-text">Sem comunicação</span>
                                    </div>
                                </DropdownItem>
                                <DropdownItem onClick={() => this.props.changeFilterGatewayState(3)}>
                                    <div className="status-gateway-container" style={{gap: "3px", cursor: "pointer"}} >
                                        <div className="status-gateway yellow" style={{cursor: "pointer"}}></div> 
                                        <span className="status-gateway-text">Alerta</span>
                                    </div>
                                </DropdownItem>
                                <DropdownItem onClick={() => this.props.changeFilterGatewayState(4)}>
                                    <div className="status-gateway-container" style={{gap: "3px", cursor: "pointer"}} >
                                        <div className="status-gateway black" style={{cursor: "pointer"}}></div> 
                                        <span className="status-gateway-text">Inativo</span>
                                    </div>
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>
                </div>

                <div style={{overflowY: "auto", overflowX: "hidden", height: "300px", width: "100%", marginTop: "5px", left: "0"}}>
                    {
                        gateways.map((gateway, index) => {

                            const status = {
                                '1': 'green',
                                '2': 'red',
                                '3': 'yellow',
                                '4': 'black',
                            }

                            return(
                                <div className="item-gateway-list" style={{padding: "0 10px"}} key={index} onClick={() => setView(gateway.latitude, gateway.longitude)}>
                                    <div className="d-flex align-items-center" style={{gap: "10px"}}>
                                        <div className={`status-gateway ${status[gateway.state]}`}></div>
                                        <span className="label-truncate" style={{fontSize: "15px", width: "150px"}} title={gateway.nome}>
                                            <Link to={`/lns/gateway/${gateway.gateway_id}/editar?dashboard=true`} className="link-gateway-editar">
                                            {gateway.nome}
                                            </Link>
                                        </span>
                                    </div>
                                    <div className="container-quantidade label-truncate" title={`${gateway.quantidade_dispositivos || 0} Dispositivos`}> {gateway.quantidade_dispositivos || 0} Dispositivos </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        )
    }
}

export default GatewayList
